// src/Router/RequirePermRoute.jsx
import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { canSeeRoute, getCurrentUserPerms, isCurrentUserAdmin } from "../utils/perm";
import { useSelector, shallowEqual } from "react-redux";

export default function RequirePermRoute({ route, children }) {
  const location = useLocation();
  const user = useSelector((s) => s?.auth?.user, shallowEqual);
  const userPerms = getCurrentUserPerms(user?.permissions || []);
  const isAdmin = isCurrentUserAdmin(user) || userPerms.includes("*");

  if (canSeeRoute(userPerms, route, { isAdmin })) return children;

  return <Navigate to="/error-404" state={{ from: location }} replace />;
}

RequirePermRoute.propTypes = {
  route: PropTypes.shape({
    path: PropTypes.string,
    meta: PropTypes.shape({
      perm: PropTypes.string,
      action: PropTypes.oneOf(["read", "write"]),
      anyPerms: PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape({
            perm: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["read", "write"]),
          }),
        ])
      ),
    }),
    element: PropTypes.node,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }).isRequired,
  children: PropTypes.node.isRequired,
};
